import { IProcessXmlFormFieldParsed } from '~/store/modules/processes/types';

import { Validations } from '../validation/types';

export enum FieldVariableType {
  STRING = 'string',
  ENUM = 'enum',
  LONG = 'long',
  BOOLEAN = 'boolean',
  DATE = 'date',
  CUSTOM_TYPE = 'custom type',
}

export interface ProcessFormField {
  id: string;
  label: string;
  type: FieldVariableType;
  validations: Validations;
  defaultValue?: unknown;
}

export interface RawProcessFormEnumOption {
  props: {
    id: string;
    name: string;
  };
}
export interface ProcessFormEnumOption {
  label: string;
  value: string;
}

export interface ProcessFormEnumField extends ProcessFormField {
  options: Array<ProcessFormEnumOption>;
}

export interface ProcessFormValues {
  [id: string]: unknown | undefined;
}

export type ProcessForm = Array<ProcessFormField>;

export type RawProcessForm = Array<IProcessXmlFormFieldParsed>;
